import { makeObservable, observable, action } from 'mobx';
import { Subject } from 'rxjs';
import { NodeBaseDto } from '../../types';
import { InputBaseModel } from '..';
import { SourceModelBase } from '../../../custom_shared/models';

export default abstract class NodeBaseModel {
    readonly id: string;

    readonly type: string;

    readonly name: string;

    readonly inputValueChangeSubject = new Subject<InputBaseModel>();

    readonly inputValidationSubject = new Subject<InputBaseModel>();

    childNodes: NodeBaseModel[] = [];

    hasError: boolean = false;

    constructor(data: NodeBaseDto) {
        this.id = data.id;
        this.type = data.type;
        this.name = data.name;

        makeObservable(this, {
            childNodes: observable,
            hasError: observable,
            setHasError: action,
            setChildNodes: action
        });
    }

    setChildNodes(childNodes: NodeBaseModel[]) {
        this.childNodes = childNodes;
    }

    setHasError(hasError: boolean) {
        this.hasError = hasError;
    }

    getInputByGuid(guid: string): InputBaseModel | undefined {
        const input = this.inputs.find(i => i.guid === guid);

        if (input) {
            return input;
        }

        for (const childNode of this.childNodes) {
            const childInput = childNode.getInputByGuid(guid);

            if (childInput) {
                return childInput;
            }
        }

        return undefined;
    }

    get isValid(): boolean {
        return this.inputs.filter(i => i.required).every(i => i.hasValue);
    }

    abstract refreshExpandedState(): void;

    abstract update(data: NodeBaseDto, sources: SourceModelBase[]): void;

    abstract get inputs(): InputBaseModel[];

    abstract get dto(): NodeBaseDto;

    abstract getInputsAtSameLevel(inputGuid: string): InputBaseModel[];
}
